import React from 'react'
import { cm } from '~/utils'

export interface RadioOption {
  value: string
  content: React.ReactNode
}

export interface RadioGroupV2Props {
  options: RadioOption[]
  selectedValue: string
  onValueChange: (value: string) => void
  className?: string
}

interface RadioItemProps {
  isSelected: boolean
  onClick: () => void
  content: React.ReactNode
}

function RadioItem({ content, isSelected, onClick }: RadioItemProps) {
  return (
    <div
      className={cm(
        'flex items-center cursor-pointer transition-colors hover:bg-[rgba(0,0,0,0.02)] p-3',
        isSelected && 'bg-[rgba(0,0,0,0.04)] rounded-[12px]'
      )}
      onClick={onClick}
    >
      {/* Radio Button */}
      <div className='flex items-center justify-center rounded-[12px] shrink-0 size-[36px] mr-[7px]'>
        <div
          className={cm(
            'size-[16px] rounded-full border-2 flex items-center justify-center transition-colors',
            isSelected
              ? 'border-[#65558F] bg-[#65558F]'
              : 'border-[#8E8E8E] hover:border-[rgba(0,0,0,0.45)]'
          )}
        >
          {isSelected && (
            <svg
              width='10'
              height='8'
              viewBox='0 0 10 8'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M1 4L3.5 6.5L9 1'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
        </div>
      </div>
      {content}
    </div>
  )
}

export function RadioGroupV2({
  options,
  selectedValue,
  onValueChange,
  className
}: RadioGroupV2Props) {
  return (
    <div className={cm('flex flex-col', className)}>
      {options.map(option => (
        <RadioItem
          key={option.value}
          isSelected={selectedValue === option.value}
          onClick={() => onValueChange(option.value)}
          content={option.content}
        />
      ))}
    </div>
  )
}
